let lastWindowState = window.innerWidth > 1025 ? "large" : "small";

class Modal {
    static $instances = [];

    static instance(modalIdentifier) {
        return Modal.$instances[modalIdentifier] ?? null;
    }

    static add(modalIdentifier) {
        let modal = document.querySelector(modalIdentifier);
        if (modal) {
            Modal.$instances[modalIdentifier] = new Modal(modalIdentifier, modal);
        }
        return Modal.instance(modalIdentifier);
    }

    constructor(modalIdentifier, modal) {
        this.modalIdentifier = modalIdentifier;
        this.modal = modal;
        this.headerTitle = this.modal.querySelector("#c-modal-header-title");
        this.overlay = this.modal.querySelector(".c-modal-overlay");
        this.closeButton = this.modal.querySelector(".c-modal-close-button");
        this.content = this.modal.querySelector(".c-modal-content");
        this.modalLoader = this.modal.querySelector('.c-loader-wrapper');
        this.modalBody = this.modal.querySelector('.c-modal-body');
        this.modalBodyInner = this.modal.querySelector('.c-modal-body-inner');
        this.attachEvents();
    }

    showOverlay(){
        this.modalBody.classList.add('c-modal-body-overlay-loader');
    }

    hideOverlay(){
        this.modalBody.classList.remove('c-modal-body-overlay-loader');
    }

    doNotAllowCloseOnBody() {
        this.overlay.classList.add('c-modal-prevent-close-on-body');
    }

    allowCloseOnBody() {
        this.overlay.classList.remove('c-modal-prevent-close-on-body');
    }

    showCloseIcon() {
        this.closeButton.classList.remove('c-hidden');
    }

    hideCloseIcon() {
        this.closeButton.classList.add('c-hidden');
    }

    setTitle(title) {
        this.headerTitle.innerText = title;
    }

    showLoader(withOverlay = true) {
        if (withOverlay) {
            this.modalBody.classList.add('c-modal-body-overlay-loader');
        }
        else {
            tmUtils.hideElementsForSelector(this.modalBodyInner);
        }
        tmUtils.showElementsForSelector(this.modalLoader);
    }

    hideLoader() {
        tmUtils.hideElementsForSelector(this.modalLoader);
        tmUtils.showElementsForSelector(this.modalBodyInner);
        this.modalBody.classList.remove('c-modal-body-overlay-loader');
    }

    attachEvents() {
        this.closeButton?.addEventListener("click", () => this.close());

        this.overlay?.addEventListener("click", (event) => {
            if (!this.content.contains(event.target) && !this.overlay.classList.contains('c-modal-prevent-close-on-body')) {
                this.close();
            }
        });

        const backToTopElements = this.overlay.querySelectorAll('a');

        if ( backToTopElements.length ){
            backToTopElements.forEach(function(element) {
                if (element.textContent.includes('Back to top')) {
                    element.addEventListener('click', function(e) {
                        e.preventDefault();
                        const modalBody = element.closest('.c-modal-body');
                        if (modalBody) {
                            modalBody.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                        }
                    });
                }
            });
        }
    }

    open( tab = null ) {
        this.modal.classList.add("open");
        setTimeout(() => this.modal.querySelector(".c-modal-content").classList.add("open"), 100);

        if ( jQuery(this.modal).find(".c-modal-desktop-r-chat-mobile-footer-slide-in").length ){
            if (lastWindowState === "large") {
                $("body").removeClass("body-no-scroll");
                $("html").removeClass("html-modal-open");
            } else {
                $("body").addClass("body-no-scroll");
                $("html").addClass("html-modal-open");
            }
        }else{
            document.body.classList.add("body-no-scroll");
            document.querySelector("html").classList.add("html-modal-open");
        }

        if (  tab !== null ){
            this.modal.querySelector('[data-tab-item-key="' + tab + '"]').click();
        }

        if ( tab === null && this.modal.querySelector('[data-tab-item-key]') ){
            this.modal.querySelector('[data-tab-item-key]').click();
        }

        jQuery(document).trigger('tmModal_open_' + this.modalIdentifier);
    }

    close() {
        let modalTimeOutMs = 0;

        this.modal.querySelector(".c-modal-content").classList.remove("open");
        this.modal.querySelector(".c-modal-content").classList.add("closing");
        if ( this.modal.querySelector(".c-modal-desktop-r-chat-mobile-footer-slide-in") ) {
            modalTimeOutMs = 400;

            setTimeout( () => {
                this.modal.classList.remove("open")
                this.modal.querySelector(".c-modal-content").classList.remove("closing");
            }, modalTimeOutMs);
        }

        if ( this.modal.querySelector(".c-modal-desktop-r-mobile-f") || ( window.innerWidth <= 1025 && this.modal.querySelector(".c-modal-mobile-footer-slide-in") ) ) {
            modalTimeOutMs = 250;

            if ( this.modal.querySelector(".c-modal-mobile-footer-slide-in") ) {
                modalTimeOutMs = 550;
            }
            setTimeout( () => {
                this.modal.classList.remove("open")
                this.modal.querySelector(".c-modal-content").classList.remove("closing");
            }, modalTimeOutMs);
        }
        else {
            this.modal.classList.remove("open");
        }

        if (document.querySelectorAll(".overlay-show").length === 0) {
            document.body.classList.remove("body-no-scroll");
            document.querySelector("html").classList.remove("html-modal-open");
        }
        jQuery(document).trigger('tmModal_closed_' + this.modalIdentifier);
    }
}


jQuery(document).on('attachAllDocumentModals', function () {
    document.querySelectorAll("[data-modal-target]").forEach(modalSelector => {
        if (modalSelector.getAttribute("data-modal-events-attached") !== '1') {
            let modalIdentifier = modalSelector.getAttribute("data-modal-target");
            let tab = modalSelector.getAttribute("data-modal-tab") ?? null;
            let modal = Modal.add(modalIdentifier);
            if (modal) {
                let eventType = 'click';
                if ( typeof tmUtils !== 'undefined' && tmUtils.isMobileOrTablet() && modalSelector.getAttribute('data-modal-target') === '#c-language-modal' ){
                    eventType = 'touchstart';
                }
                modalSelector.addEventListener(eventType, () => modal.open(tab));
            }
            modalSelector.setAttribute("data-modal-events-attached", "1");
        }
    });
});

/* Initialise for all models */
document.addEventListener("DOMContentLoaded", () => {
    $(window).on("resize", handleResize);
    jQuery(document).trigger('attachAllDocumentModals');
});

function handleResize() {
    let currentState = window.innerWidth > 1025 ? "large" : "small";
    if (currentState !== lastWindowState) {
        lastWindowState = currentState;
    }

    // Check modal open only if modal exists
    let $modal = $(".c-modal-desktop-r-chat-mobile-footer-slide-in .open");
    if ($modal.length) {
        if (currentState === "large") {
            $("body").removeClass("body-no-scroll");
            $("html").removeClass("html-modal-open");
        } else {
            $("body").addClass("body-no-scroll");
            $("html").addClass("html-modal-open");
        }
    }
}
